var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 41,
    viewBox: "0 0 29 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9623 13.266C28.7484 10.73 27.9557 8.40522 26.4963 6.30425C24.5336 3.4698 21.879 1.55531 18.5575 0.585632C16.167 -0.110547 13.7388 -0.172706 11.3106 0.36186C8.84469 0.908858 6.66811 2.02772 4.80607 3.69358C2.50369 5.75725 1.01909 8.2809 0.339696 11.277C-0.037744 12.9677 -0.100651 14.6833 0.150976 16.3989C0.46551 18.5123 1.15748 20.5262 2.00043 22.478C3.42213 25.7475 5.24642 28.7809 7.24685 31.7272C8.93276 34.2136 10.757 36.6005 12.682 38.9004C13.2607 39.5965 13.8646 40.2927 14.4685 41.0138C14.5818 40.8895 14.6573 40.8149 14.7202 40.7278C16.5696 38.6144 18.331 36.4389 19.9792 34.1763C22.0928 31.2797 24.0681 28.2961 25.7163 25.1011C26.7354 23.1244 27.6286 21.0981 28.2451 18.9598C28.8113 17.095 29.1258 15.2054 28.9623 13.266ZM14.4685 19.4695C11.751 19.4819 9.29761 17.2939 9.32278 14.3103C9.34794 11.3391 11.839 9.13869 14.6698 9.23815C17.3874 9.32517 19.7024 11.5132 19.6646 14.4346C19.6521 17.2442 17.2742 19.5192 14.4685 19.4695Z",
    fill: "#EB5E35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 41,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b3974df9.svg";
export { ForwardRef as ReactComponent };